export default [
  {
    component: () => import("pages/MentionExpectationsList.vue"),
    meta: {
      accessLevel: "limited",
      title: "Expected Mention Requests",
    },
    name: "mention-expectations-index",
    path: "/mention_expectations",
  },
  {
    component: () => import("pages/MentionExpectationEdit.vue"),
    meta: {
      accessLevel: "limited",
      title: "Edit Expected Mention Request",
    },
    name: "mention-expectations-edit",
    path: "/mention_expectations/:itemId/edit",
    props: true,
  },
  {
    component: () => import("pages/MentionExpectationEdit.vue"),
    meta: {
      accessLevel: "limited",
      title: "New Expected Mention Request",
    },
    name: "mention-expectations-new",
    path: "/mention_expectations/new",
    props: true,
  },
];
